import { render, staticRenderFns } from "./LogoFreelanceHr.vue?vue&type=template&id=5f50f2a8&scoped=true&"
import script from "./LogoFreelanceHr.vue?vue&type=script&lang=js&"
export * from "./LogoFreelanceHr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f50f2a8",
  null
  
)

export default component.exports